module.exports = __webpack_public_path__ + "70f500ce921897df6fbbb1589c27cdf1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/dollar_general_2023_chart.png
// module id = 1667
// module chunks = 0